import useSWR from 'swr'

import { backendFetchResult, backendFetchResultData, Result } from '../common/api'
import { gidToId } from '../common/helpers'
import { SellingPlanGroup, SellingPlanGroupPWData, SellingPlanWorkflows } from './models-common'
import { SellingPlanGroupInput } from './models-input'

// #region Internal types

export const fetchSellingPlanGroup = async (id: string): Promise<SellingPlanGroup> => {
  const res = await backendFetchResult<SellingPlanGroup>('GET', `/plans/${id}`)

  if (res.status !== 'success' || !res.data) {
    return Promise.reject(`Unknown error`)
  }

  return res.data
}

export const createSellingPlanGroup = async (
  input: SellingPlanGroupInput,
  pwData: SellingPlanGroupPWData
): Promise<Result<SellingPlanGroup>> => {
  const body = JSON.stringify({ input, pwData })

  return await backendFetchResult('POST', `/plans`, { body })
}

export const updateSellingPlanGroup = async (
  gid: string,
  input: SellingPlanGroupInput,
  pwData: SellingPlanGroupPWData
): Promise<Result<SellingPlanGroup>> => {
  const id = gidToId(gid)
  const body = JSON.stringify({ input, pwData })

  return await backendFetchResult('PATCH', `/plans/${id}`, { body })
}

export const fetchSellingPlanWorkflows = async (_: string, id?: string) => {
  if (!id) {
    return Promise.resolve(null)
  }

  return await backendFetchResultData<SellingPlanWorkflows>('GET', `/plans/${id}/workflows`)
}

export const useSellingPlanWorkflowsSWR = (id?: string) =>
  useSWR<SellingPlanWorkflows | null>(['selling-plan-workflows', id], fetchSellingPlanWorkflows)
